// extracted by mini-css-extract-plugin
export default {"installButton":"DownloadPwaButton_installButton__FK6fW"};